import api from "@api";
import { components } from "@api/schema";
import { IPaymentOrigin } from "@modules/PaymentProcessing/services/payments";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import { EstimationState } from "@modules/ServiceRequest/types";
import { ID } from "@types";

export const API_PATH = "service_offers";

export type IServiceOffer = components["schemas"]["serviceOffer"] & {
  estimationState?: EstimationState;
};

export interface IGetServiceOfferOptions {
  includes?: "expenses"[];
}

export const getServiceOffer = (id: ID, options?: IGetServiceOfferOptions) => {
  return api.get<IGetServiceOfferOptions, IServiceOffer>(
    [API_PATH, String(id)].join("/"),
    options
  );
};

export interface IAcceptServiceOfferOptions {
  // TODO: make this origin come from api schema types
  origin: IPaymentOrigin<PaymentMethodType>;
}

export const acceptServiceOffer = (
  id: ID,
  data?: IAcceptServiceOfferOptions
) => {
  return api.post<IAcceptServiceOfferOptions, undefined>(
    [API_PATH, String(id), "acceptances"].join("/"),
    data
  );
};
